export const baseUrl = process.env.REACT_APP_BASE_API_URL;
export const baseUrlFile=process.env.REACT_APP_BASE_API_URL_FILEUPLOAD;